var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 41.25,
    height: 41.25,
    rx: 7.875,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 41.25,
    height: 41.25,
    rx: 7.875,
    stroke: "#E7E8E9",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.616 29C16.1713 29 15.791 28.8416 15.475 28.525C15.159 28.2083 15.0007 27.8286 15 27.386V15H14.5C14.358 15 14.2393 14.952 14.144 14.856C14.0487 14.76 14.0007 14.641 14 14.499C13.9993 14.357 14.0473 14.2383 14.144 14.143C14.2407 14.0476 14.3593 14 14.5 14H18C18 13.7933 18.0767 13.6133 18.23 13.46C18.3833 13.3066 18.5633 13.23 18.77 13.23H23.23C23.4367 13.23 23.6167 13.3066 23.77 13.46C23.9233 13.6133 24 13.7933 24 14H27.5C27.642 14 27.7607 14.048 27.856 14.144C27.9513 14.24 27.9993 14.359 28 14.501C28.0007 14.643 27.9527 14.7616 27.856 14.857C27.7593 14.9523 27.6407 15 27.5 15H27V27.385C27 27.829 26.8417 28.209 26.525 28.525C26.2083 28.841 25.8283 28.9993 25.385 29H16.616ZM26 15H16V27.385C16 27.5643 16.0577 27.7116 16.173 27.827C16.2883 27.9423 16.436 28 16.616 28H25.385C25.5643 28 25.7117 27.9423 25.827 27.827C25.9423 27.7116 26 27.5643 26 27.385V15ZM19.308 26C19.45 26 19.569 25.952 19.665 25.856C19.761 25.76 19.8087 25.6413 19.808 25.5V17.5C19.808 17.358 19.76 17.2393 19.664 17.144C19.568 17.0486 19.449 17.0006 19.307 17C19.165 16.9993 19.0463 17.0473 18.951 17.144C18.8557 17.2406 18.808 17.3593 18.808 17.5V25.5C18.808 25.642 18.856 25.7606 18.952 25.856C19.048 25.952 19.1667 26 19.308 26ZM22.693 26C22.835 26 22.9537 25.952 23.049 25.856C23.1443 25.76 23.192 25.6413 23.192 25.5V17.5C23.192 17.358 23.144 17.2393 23.048 17.144C22.952 17.048 22.8333 17 22.692 17C22.55 17 22.431 17.048 22.335 17.144C22.239 17.24 22.1913 17.3586 22.192 17.5V25.5C22.192 25.642 22.24 25.7606 22.336 25.856C22.432 25.9513 22.551 25.9993 22.693 26Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.3a5e1831d417a9ec61e76fd771913419.svg";
export { ForwardRef as ReactComponent };